module.exports = __webpack_public_path__ + "img/19-solar-offspring.4d233130.png";